module.exports = __webpack_public_path__ + "img/button_close_info.8e4986a5.svg";